/**
 * Menu Item Popover Handler
 * Adds active class to parent when popovertarget button is clicked
 */

class MenuItemPopover {
  constructor() {
    this.init();
  }

  init() {
    // Find all buttons with popovertarget attribute
    const popoverButtons = document.querySelectorAll('button[popovertarget]');
    
    popoverButtons.forEach(button => {
      this.setupPopoverToggle(button);
    });
  }

  setupPopoverToggle(button) {
    const popoverId = button.getAttribute('popovertarget');
    const popover = document.getElementById(popoverId);
    const topParent = button.closest('.single-mega-menu');
    const menuId = topParent ? topParent.getAttribute('data-menu-id') : null;
    const isMegaMenu = topParent ? topParent.getAttribute('data-mega-menu') === 'true' : false;
    
    if (!popover || !topParent) return;

    // Listen for popover show/hide events
    popover.addEventListener('toggle', (event) => {
      if (event.newState === 'open') {
        topParent.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      } else {
        topParent.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      }
    });

    // Also listen for button clicks for immediate feedback
    button.addEventListener('click', () => {
      // Toggle active class immediately on click
      if (popover.matches(':popover-open')) {
        topParent.classList.remove('active');
        button.setAttribute('aria-expanded', 'false');
      } else {
        topParent.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    });

    // get content for mega menu
    if (isMegaMenu) {
      const megaMenuContent = topParent.querySelector('.mega-menu-content');
      if (megaMenuContent) {
        
        let menuContent= document.querySelector(`.menu-section-component[data-menu-id="${menuId}"]`);
        // move content to mega menu
        if (menuContent) {
          megaMenuContent.innerHTML = menuContent.innerHTML;
        }
        // remove from original location
        if (menuContent && menuContent.parentNode) {
          menuContent.parentNode.removeChild(menuContent);
        }
      }  
    }


  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MenuItemPopover();
  });
} else {
  new MenuItemPopover();
}

// Also initialize after any dynamic content changes
document.addEventListener('shopify:section:load', () => {
  new MenuItemPopover();
});